(function () {
  // --- Logs de smoke test ---
  if (typeof console !== 'undefined' && console.log) {
    console.log("[INFINITE] ES5 file loaded");
  }

  // Utilidades (ES5)
  function getSectionRoot(el) {
    var start = (el && el.nodeType === 1) ? el : document;
    // sin optional chaining
    var curr = start;
    while (curr && curr !== document.body) {
      if (curr.matches && (curr.matches('section, .shopify-section'))) return curr;
      curr = curr.parentElement;
    }
    // fallback: primer section/.shopify-section o body
    return document.querySelector('section, .shopify-section') || document.body;
  }

  function toSectionURL(url, sectionId) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'section_id=' + encodeURIComponent(sectionId);
  }

  // Inicializador
  function initInfiniteCollection(root) {
    var sectionRoot = getSectionRoot(root || document);
    if (!sectionRoot) return;

    var grid = sectionRoot.querySelector('#product-grid');
    if (!grid) return;

    var sectionId  = grid.getAttribute('data-section-id') || grid.getAttribute('data-id') || 'UNKNOWN';
    var pagination = sectionRoot.querySelector('#CollectionPagination-' + sectionId);
    var controls   = sectionRoot.querySelector('#InfiniteControls-' + sectionId);
    if (!controls) return;

    // Progressive enhancement
    document.documentElement.classList.add('js');
    if (pagination) pagination.style.display = 'none';
    controls.setAttribute('data-enhanced', 'true');

    var btn      = controls.querySelector('[data-load-more]');
    var spinner  = controls.querySelector('.infinite-spinner');
    var sentinel = controls.querySelector('.infinite-sentinel');

    // Botón oculto por defecto (solo ante error)
    if (btn) { btn.hidden = true; btn.disabled = false; }

    // Sentinel con caja invisible (como en el debug que te funcionaba)
    if (sentinel) {
      sentinel.style.display = 'block';
      sentinel.style.width = '100%';
      sentinel.style.height = '60px';
      sentinel.style.opacity = '0';
      sentinel.style.pointerEvents = 'none';
    }

    var nextURL   = grid.getAttribute('data-next-url') || null;
    var isLoading = false;

    // Colección corta → quita controles
    if (!nextURL) {
      controls.parentNode && controls.parentNode.removeChild(controls);
      return;
    }

    var observer = null;
    var observedLastItem = null;

    function loadMore(trigger) {
      if (isLoading || !nextURL) return;
      isLoading = true;
      if (spinner) spinner.hidden = false;
      if (btn) btn.disabled = true;

      var fetchUrl = toSectionURL(nextURL, sectionId);

      // fetch ES5 (está bien en navegadores modernos; si necesitases XHR, te paso versión XHR)
      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(res){
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html){
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (!newGrid) throw new Error('Respuesta sin #product-grid');

          var newItems = newGrid.querySelectorAll('.grid__item, [data-grid-item]');
          for (var i = 0; i < newItems.length; i++) {
            grid.appendChild(newItems[i]);
          }

          var updatedNext = newGrid.getAttribute('data-next-url');
          nextURL = updatedNext || null;
          grid.setAttribute('data-next-url', updatedNext || '');

          // Re-observar nuevo último <li> (fallback)
          if (observer) {
            var newLast = grid.querySelector('li:last-child');
            if (newLast && newLast !== observedLastItem) {
              if (observedLastItem) observer.unobserve(observedLastItem);
              observer.observe(newLast);
              observedLastItem = newLast;
            }
          }

          if (!nextURL) {
            // Fin → quitar controles y listeners
            controls.parentNode && controls.parentNode.removeChild(controls);
            if (observer) observer.disconnect();
            window.removeEventListener('scroll', scrollFallback, passiveOpts);
          } else {
            if (btn) { btn.hidden = true; btn.disabled = false; }
          }
        })
        .catch(function(e){
          // Error → muestra botón para reintentar manualmente
          if (btn) { btn.hidden = false; btn.disabled = false; }
          if (typeof console !== 'undefined' && console.error) {
            console.error('[Infinite Scroll] Error:', e);
          }
        })
        .finally
        ? // Algunos navegadores antiguos no tienen finally en Promises
          fetchFinally()
        : fetchFinallyFallback();

      function fetchFinally(){ // para navegadores con .finally
        if (spinner) spinner.hidden = true;
        isLoading = false;
      }
      function fetchFinallyFallback(){ // fallback simple
        try { if (spinner) spinner.hidden = true; } catch (e) {}
        isLoading = false;
      }
    }

    if (btn) btn.addEventListener('click', function(){ loadMore('button'); });

    // IntersectionObserver (con dobles objetivos: sentinel + último <li>)
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries){
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { loadMore('observer'); break; }
        }
      }, {
        root: null,               // si tu layout scrollea en contenedor, aquí iría ese root
        rootMargin: '1000px 0px', // prefetch agresivo
        threshold: 0
      });

      if (sentinel) observer.observe(sentinel);
      var lastItem = grid.querySelector('li:last-child');
      if (lastItem) {
        observer.observe(lastItem);
        observedLastItem = lastItem;
      }
    }

    // Fallback por scroll (por si IO no dispara en algún navegador)
    var passiveOpts = { passive: true };
    function scrollFallback() {
      if (isLoading || !nextURL) return;
      var dist = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      if (dist < 800) loadMore('scroll-fallback');
    }
    window.addEventListener('scroll', scrollFallback, passiveOpts);
  }

  // Exponer e inicializar
  window.initInfiniteCollection = initInfiniteCollection;

  document.addEventListener('DOMContentLoaded', function () {
    console && console.log && console.log("[INFINITE] DOMContentLoaded (ES5)");
    var grid = document.getElementById('product-grid');
    if (grid) initInfiniteCollection(grid);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initInfiniteCollection(e.target);
  });
})();


